import { del, get, patch, post } from "../utils/api/apiCaller";
import { ENDPOINTS } from "../utils/api/endpoints";

export const getInspectorAssignmentProjects = (params: Record<string, unknown>) =>
  get(ENDPOINTS.INSPECTOR_ASSIGNMENT.PROJECTS, params);

export const removeInspectorAssignment = (assignmentId: string) =>
  del(ENDPOINTS.INSPECTOR_ASSIGNMENT.REMOVE(assignmentId));

export const getInspectors = (page = 1, limit = 5) =>
  get(ENDPOINTS.INSPECTOR_ASSIGNMENT.INSPECTORS(page, limit));

export const createInspectorAssignment = (projectId: string, data: Record<string, unknown>) =>
  post(ENDPOINTS.INSPECTOR_ASSIGNMENT.CREATE(projectId), data);

export const getInspectorProjectDetails = (page = 1, limit = 10) =>
  get(ENDPOINTS.INSPECTOR_ASSIGNMENT.PROJECT_DETAILS, { page, limit });

export const getInspectorLeaves = (inspectorId: string) =>
  get(ENDPOINTS.INSPECTOR_ASSIGNMENT.GET_LEAVES(inspectorId));

export const addInspectorLeave = (
  inspectorId: string,
  data: { leaveFrom: string; leaveTo: string; note?: string },
) => post(ENDPOINTS.INSPECTOR_ASSIGNMENT.ADD_LEAVE(inspectorId), data);

export const deleteInspectorLeave = (leaveId: string) =>
  del(ENDPOINTS.INSPECTOR_ASSIGNMENT.DELETE_LEAVE(leaveId));

export const editInspectorLeave = (
  leaveId: string,
  data: { leaveFrom: string; leaveTo: string; note?: string },
) => patch(ENDPOINTS.INSPECTOR_ASSIGNMENT.EDIT_LEAVE(leaveId), data);

export interface VacationProjectAssignment {
  projectId: string;
  inspectorId: string;
  role: "primary" | "cover";
  notifyNewInspector?: boolean;
  notifyPrevInspector?: boolean;
}

export interface VacationPayload {
  leaveFrom: string;
  leaveTo: string;
  leaveType?: string;
  note?: string;
  projects?: VacationProjectAssignment[];
}

export const assignInspectorVacation = (
  inspectorId: string,
  data: VacationPayload,
) => post(ENDPOINTS.INSPECTOR_ASSIGNMENT.ASSIGN_VACATION(inspectorId), data);

export const updateInspectorVacation = (
  leaveId: string,
  data: VacationPayload,
) => patch(ENDPOINTS.INSPECTOR_ASSIGNMENT.UPDATE_VACATION(leaveId), data);

export const getVacationProjects = (leaveId: string) =>
  get(ENDPOINTS.INSPECTOR_ASSIGNMENT.VACATION_PROJECTS(leaveId));
